export default [{
  path: '/visitor',
  name: 'visitor',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/visitor/visitor/index')
}]
